module.exports = __webpack_public_path__ + "img/avatar5.456b2b1d.png";